















































































































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import Purchase from "../../../usecases/accounting/purchase";
import PurchaseItemModel from "../../../usecases/accounting/purchase-item";
import PurchaseItem from "../components/PurchaseItem.vue";
import PurchaseHeader from "../components/PurchaseHeader.vue";
import VToolbar from "../../common/components/VToolbar.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { getOtherCompanies } from "../../../api/company-api";
import GroupFilter from "@/entities/group-filter";
import PurchaseService from "@/usecases/accounting/purchase-service";
import PurchaseApi from "../../../api/accounting/purchase-api";
import { client } from "../../../api/request";
import PurchaseStatus from "@/usecases/accounting/purchase-status";
import PurchaseStatusTranslater from "@/usecases/accounting/purchase-status-translater";
import UnitApi from "@/accounting/api/unit-api";
import UnitOption from "../presenters/unit-option";
import PrintApi from "../../../api/accounting/print-api";
import SubmitButton from "@/components/SubmitButton.vue";
import TextTemplateModal from "@/views/TextTemplateModal.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import isDateBeforeServiceCreated from "@/helpers/isDateBeforeServiceCreated";

const printApi = new PrintApi(client);
const purchaseApi = new PurchaseApi(client);
const unitApi = new UnitApi(client);
const service = new PurchaseService(purchaseApi);

@Component({
  components: {
    TextTemplateModal,
    VToolbar,
    PurchaseHeader,
    PurchaseItem,
    SubmitButton,
    LoadingButton
  }
})
export default class EditPurchasePage extends Vue {
  @Prop({ required: true }) id!: string;

  textTemplateModalOpen = false;

  printing: boolean = false;

  purchase = new Purchase();

  vendorOptions: SelectOption[] = [];
  unitOptions: SelectOption[] = [];

  get statusOptions() {
    return PurchaseStatus.all().map(value => ({
      value,
      text: PurchaseStatusTranslater.toJp(value)
    }));
  }

  status: "" | "progressing" = "";

  async save() {
    this.status = "progressing";
    try {
      if (
        !isDateBeforeServiceCreated(
          this.purchase.dateOfIssue,
          this.$store.state.service.createdDate
        )
      )
        return;
      await purchaseApi.save(this.purchase);
      await this.initPurchase();
      alert("保存しました。");
    } catch (error) {
      alert(error[0] || error);
    } finally {
      this.status = "";
    }
  }

  async destroy() {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await purchaseApi.destroy(Number(this.id));
    this.goListPage();
  }

  goListPage() {
    this.$router.push({
      name: "purchase"
    });
  }

  appendTo(items: PurchaseItemModel[]) {
    items.push(new PurchaseItemModel());
    this.calculate();
  }

  remove(items: PurchaseItemModel[], i: number) {
    items.splice(i, 1);
    this.calculate();
  }

  calculate() {
    this.purchase = service.calculate(this.purchase);
  }

  protected created() {
    this.initPurchase();
    this.initVendorList();
    this.initUnitList();
  }

  async createPdf(id: number, printsExcludeTax: boolean) {
    if (!this.printing) {
      this.printing = true;
      try {
        const url = await printApi.getPurchasePrint(
          id,
          this.$store.state.accessToken,
          printsExcludeTax
        );
        window.open(url, "発注書印刷");
      } catch (e) {
        alert("印刷に失敗しました。しばらく待って改めてお試しください。");
      } finally {
        this.printing = false;
      }
    } else {
      alert("印刷中です");
    }
  }

  private async initPurchase() {
    this.purchase = await service.find(this.id);
  }

  private async initVendorList() {
    const companies = await getOtherCompanies();
    const filter = new GroupFilter({ role: "vendor" });
    const vendors = companies.filter(c => filter.isSatisfied(c));
    this.vendorOptions = vendors.map(v => ({
      text: v.name,
      value: String(v.office.officeId)
    }));
  }

  private async initUnitList() {
    this.unitOptions = [
      { text: "", value: "" },
      ...(await unitApi.findAll()).map(UnitOption)
    ];
  }

  addTextToMention(text: string) {
    if (this.purchase.mention) {
      this.purchase.mention += "\n";
    }
    this.purchase.mention += text;
    this.textTemplateModalOpen = false;
  }

  addNewItem(): void {
    this.purchase.items.push(new PurchaseItemModel());
  }

  addNewItems(itemsCount: number): void {
    for (let i = 0; i < itemsCount; i++) {
      this.purchase.items.push(new PurchaseItemModel());
    }
  }

  removeAllItems(): void {
    if (!confirm("全ての項目を削除します。よろしいですか？")) return;
    this.purchase.items = [];
  }
}
